import React from "react";

function ArrowsSvg() {
  return (
    <svg
      /* fill="#000000" */ width="28.036"
      height="38.452"
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
    >
      <g transform="translate(0 -1)">
        <g>
          <path
            d="M409.06,107.527l-7.993-39.967c-0.017-0.084-0.041-0.163-0.06-0.245C399.755,29.862,362.705,1,315.733,1
       C292.693,1,271.36,7.827,256,19.773C240.64,7.827,219.307,1,196.267,1c-46.971,0-84.022,28.862-85.274,66.315
       c-0.019,0.083-0.043,0.161-0.06,0.245l-7.993,39.967c-10.767,9.404-17.607,23.208-17.607,38.539c0,28.16,23.04,51.2,51.2,51.2
       c28.16,0,51.2-23.04,51.2-51.2c0-15.332-6.839-29.135-17.607-38.539l-7.88-39.4c1.33-7.438,15.354-15.927,34.02-15.927
       c19.627,0,34.133,9.387,34.133,17.067V461.8c-23.893,0-42.667,18.773-42.667,42.667c0,5.12,3.413,8.533,8.533,8.533h119.467
       c5.12,0,8.533-3.413,8.533-8.533c0-23.893-18.773-42.667-42.667-42.667V69.267c0-7.68,14.507-17.067,34.133-17.067
       c18.666,0,32.69,8.489,34.02,15.927l-7.88,39.401c-10.767,9.404-17.607,23.208-17.607,38.539c0,28.16,23.04,51.2,51.2,51.2
       s51.2-23.04,51.2-51.2C426.667,130.735,419.827,116.932,409.06,107.527z M136.533,180.2c-18.773,0-34.133-15.36-34.133-34.133
       c0-11.707,5.974-22.085,15.023-28.24c4.011-2.632,8.391-4.497,13.14-5.356c0.165-0.029,0.328-0.062,0.493-0.089
       c0.26-0.043,0.522-0.079,0.784-0.116c0.285-0.04,0.571-0.077,0.858-0.11c0.215-0.025,0.431-0.048,0.648-0.068
       c0.352-0.033,0.705-0.059,1.06-0.081c0.173-0.011,0.345-0.024,0.519-0.033c0.534-0.025,1.07-0.041,1.609-0.041
       s1.075,0.016,1.609,0.041c0.174,0.008,0.346,0.022,0.519,0.033c0.355,0.022,0.708,0.048,1.06,0.081
       c0.217,0.02,0.432,0.043,0.648,0.068c0.287,0.032,0.573,0.07,0.858,0.11c0.262,0.037,0.524,0.073,0.784,0.116
       c0.165,0.027,0.329,0.059,0.493,0.089c4.749,0.859,9.129,2.724,13.14,5.356c9.049,6.155,15.023,16.533,15.023,28.24
       C170.667,164.84,155.307,180.2,136.533,180.2z M140.342,95.024c-0.082-0.007-0.166-0.013-0.248-0.019
       c-0.464-0.032-0.929-0.064-1.397-0.084c-0.707-0.033-1.424-0.055-2.164-0.055s-1.457,0.022-2.164,0.055
       c-0.468,0.02-0.932,0.051-1.397,0.084c-0.083,0.006-0.166,0.012-0.248,0.019c-2.246,0.167-4.456,0.468-6.614,0.919
       c-1.086,0.201-2.158,0.415-3.231,0.63l3.413-18.773h20.48l3.413,18.773c-1.072-0.214-2.145-0.429-3.231-0.63
       C144.798,95.493,142.588,95.192,140.342,95.024z M305.493,495.933h-98.987c3.413-10.24,12.8-17.067,23.893-17.067h8.533h34.133
       h8.533C292.693,478.867,302.08,485.693,305.493,495.933z M315.733,35.133c-27.307,0-51.2,15.36-51.2,34.133V461.8h-17.067V69.267
       c0-18.773-23.893-34.133-51.2-34.133c-23.04,0-43.52,11.093-49.493,25.6h-17.92c5.12-23.893,32.427-42.667,67.413-42.667
       c21.333,0,40.96,7.68,53.76,19.627c3.413,3.413,8.533,3.413,11.947,0c12.8-12.8,32.427-19.627,53.76-19.627
       c34.987,0,62.293,18.773,67.413,42.667h-17.92C359.253,46.227,338.773,35.133,315.733,35.133z M361.813,96.573l3.413-18.773h20.48
       l3.413,18.773c-1.073-0.215-2.146-0.429-3.232-0.63c-2.158-0.451-4.367-0.752-6.612-0.919c-0.082-0.007-0.165-0.013-0.248-0.019
       c-0.464-0.032-0.929-0.064-1.396-0.083c-0.707-0.033-1.424-0.055-2.164-0.055h0l0,0c0,0,0,0,0,0c-0.74,0-1.457,0.022-2.164,0.055
       c-0.468,0.02-0.932,0.051-1.397,0.084c-0.083,0.006-0.166,0.012-0.248,0.019c-2.246,0.167-4.456,0.468-6.614,0.919
       C363.958,96.145,362.886,96.359,361.813,96.573z M375.467,180.2c-18.773,0-34.133-15.36-34.133-34.133
       c0-11.707,5.974-22.085,15.023-28.24c4.011-2.632,8.391-4.497,13.14-5.356c0.165-0.029,0.328-0.062,0.493-0.089
       c0.26-0.043,0.522-0.079,0.784-0.116c0.285-0.04,0.571-0.077,0.858-0.11c0.215-0.025,0.431-0.048,0.648-0.068
       c0.352-0.033,0.705-0.059,1.06-0.081c0.173-0.011,0.345-0.024,0.519-0.033c0.534-0.025,1.07-0.041,1.609-0.041
       s1.075,0.016,1.609,0.041c0.174,0.008,0.346,0.022,0.519,0.033c0.355,0.022,0.708,0.048,1.06,0.081
       c0.217,0.02,0.432,0.043,0.648,0.068c0.287,0.032,0.573,0.07,0.858,0.11c0.262,0.037,0.524,0.073,0.784,0.116
       c0.165,0.027,0.329,0.059,0.493,0.089c4.749,0.859,9.129,2.724,13.14,5.355c9.049,6.155,15.023,16.534,15.023,28.241
       C409.6,164.84,394.24,180.2,375.467,180.2z"
          />
        </g>
      </g>
    </svg>
  );
}

export default ArrowsSvg;
